import { Box, Text, VStack, HStack, Icon, List, ListItem, ListIcon } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { LucideIcon } from "lucide-react";

interface ProductAttributeCardProps {
  icon: LucideIcon;
  title: string;
  points: string[];
  accentColor?: string;
}

export const ProductAttributeCard: React.FC<ProductAttributeCardProps> = ({
  icon,
  title,
  points,
  accentColor = "cyan.300",
}) => {
  return (
    <Box
      bg="gray.800"
      borderRadius="lg"
      p={5}
      h="100%"
      borderWidth="1px"
      borderColor="gray.700"
      transition="border-color 0.15s"
      _hover={{ borderColor: accentColor }}
    >
      <HStack spacing={3} mb={3}>
        <Icon as={icon} boxSize={5} color={accentColor} />
        <Text fontWeight="semibold" fontSize="md" color="white">
          {title}
        </Text>
      </HStack>
      <List spacing={2}>
        {points.map((point, idx) => (
          <ListItem key={idx} fontSize="sm" color="gray.300">
            <ListIcon as={CheckCircleIcon} color={accentColor} />
            {point}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};